import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledPanelIconButton = styled(IconButton)`
    & .SWReactIcons {
        align-items: center;
        margin-right: -6px;

        & svg path {
            fill: ${colorsPalettes.blue["500"]};
        }
    }
`;
